import ForgetPassword from "./Pages/ForgetPassword/ForgetPassword";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import Course from "./Pages/Course/Course";
import ProductCategory from "./Pages/ProductCategory/ProductCategory";
import Register from "./Pages/Register/Register";
import UserPanel from "./Pages/UserPanel/UserPanel";
import Product from "./Pages/Product/Product";
import Article from "./Pages/Article/Article";
import Counseling from "./Pages/Counseling/Counseling";
import ArticleCategory from "./Pages/ArticleCategory/ArticleCategory";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Cart from "./Pages/Cart/Cart";
import CourseCategory from "./Pages/CourseCategory/CourseCategory";
import Search from "./Pages/Search/Search";
import Checkout from "./Pages/Checkout/Checkout";
import PaymentStatus from "./Pages/PaymentStatus/PaymentStatus";
const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/Register",
    element: <Register />,
  },
  {
    path: "/userpanel/*",
    element: <UserPanel />,
  },
  {
    path: "/forgetpassword",
    element: <ForgetPassword />,
  },
  {
    path: "/products",
    element: <ProductCategory />,
  }, 
  {
    path: "/courses",
    element: <CourseCategory />,
  },
  {
    path: "/course/:title",
    element: <Course />
  },
  {
    path: "/product/:title",
    element: <Product />
  },
  {
    path: "/article/:title",
    element: <Article />
  },
  {
    path: "/counseling",
    element: <Counseling />
  },
  {
    path: "/articles",
    element: <ArticleCategory />
  },
  {
    path: "/aboutus",
    element: <AboutUs />
  },
  {
    path: "/cart",
    element: <Cart />,
  },
  {
    path: "/search/:search/:category",
    element: <Search />
  },
  {
    path: "/checkout",
    element: <Checkout />
  },
  {
    path: "/paymentStatus",
    element: <PaymentStatus />
  },
  {
    path: "/Cart/OnlinePayment/:authority",
    element: <PaymentStatus />
  }
];

export default routes